<template>
  <div ref="scroll" class="w-scroll" @scroll="scrollBind">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'scroll',
    data () {
      return {
        scrollNum: 0
      }
    },
    mounted () {
      this.wScroll(this, this.$refs.scroll)
    },
    methods: {
      // 监听显示右侧悬浮菜单
      scrollBind () {
        if ($('.scrollWarp')[0]) {
          var scrollObj = $('.scrollWarp')[0].getBoundingClientRect()
          this.scrollNum = scrollObj.top
          if (this.scrollNum <= -250) {
            this.$emit('showTop', true)
          } else {
            this.$emit('showTop', false)
          }
        }
      },
      // 监听滑动
      wScroll (that, elem) {
        var startX = 0
        var startY = 0
        document.addEventListener('touchstart', function (evt) {
          var touch = evt.touches[0]
          startX = Number(touch.pageX)
          startY = Number(touch.pageY)
        })
        elem.addEventListener('touchmove', function (ev) {
          const moveEndX = ev.touches[0].pageX
          const moveEndY = ev.touches[0].pageY
          const X = moveEndX - startX
          const Y = moveEndY - startY
          // 由左向右
          if (Math.abs(X) > Math.abs(Y) && X > 0) {
            return false
          } else if (Math.abs(X) > Math.abs(Y) && X < 0) {
            // 由右向左
            return false
          } else {
            if (Math.abs(Y) > Math.abs(X) && Y > 0) {
              that.$emit('animation', false, Y, ev)
            } else if (Math.abs(Y) > Math.abs(X) && Y < 0) {
              that.$emit('animation', true, Y, ev)
            }
            var _point = ev.touches[0]
            // var _top = parseInt(elem.scrollTop)
            var _top = elem.scrollTop
            var _bottomFaVal = elem.scrollHeight - elem.offsetHeight
            if (_top > 250 || that.scrollNum <= -250) {
              that.$emit('showTop', true)
            } else {
              that.$emit('showTop', false)
            }
            if (_top === 0) {
              if (_point.clientY > startY && ev.cancelable) {
                ev.preventDefault()
              } else if (_bottomFaVal == 0) {
                ev.preventDefault()
              } else {
                ev.stopPropagation()
              }
            } else if (_top === _bottomFaVal) {
              if (_point.clientY < startY) {
                elem.scrollTop --
              } else {
                ev.stopPropagation()
              }
            } else if (_top > 0 && _top < _bottomFaVal) {
              ev.stopPropagation()
            } else {
              ev.preventDefault()
            }
          }
        }, {passive: false})
      },
      goTop () {
        this.$refs.scroll.scrollTop = 0
        this.$emit('showTop', false)
      }
    }
  }
</script>

<style scoped="scoped">
  .w-scroll {
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
</style>


// WEBPACK FOOTER //
// src/components/scroll.vue